import { defineComponent, h, computed } from 'vue';
import Prism from 'prismjs';

export default defineComponent({
  name: 'PrismComponent',

  props: {
    code: {
      type: String,
      default: '',
    },
    inline: {
      type: Boolean,
      default: false,
    },
    language: {
      type: String,
      default: 'markup',
    },
  },

  setup(props, { slots, attrs }) {
    const prismLanguage = computed(() => {
      return Prism.languages[props.language] || Prism.languages.markup;
    });

    const highlightedCode = computed(() => {
      const slotText =
        slots.default && slots.default()[0] && slots.default()[0].text
          ? slots.default()[0].text
          : '';

      const source = props.code || slotText;

      return Prism.highlight(source, prismLanguage.value, props.language);
    });

    return () => {
      const className = `language-${props.language}`;

      if (props.inline) {
        return h('code', {
          ...attrs,
          class: [attrs.class, className],
          domProps: {
            innerHTML: highlightedCode.value,
          },
        });
      }

      return h(
        'pre',
        {
          ...attrs,
          class: [attrs.class, className],
        },
        [
          h('code', {
            class: className,
            domProps: {
              innerHTML: highlightedCode.value,
            },
          }),
        ]
      );
    };
  },
});
